import inboundChains from './modules/inboud';
import inventoryChains from './modules/inventory-management';
import saleOutboundChains from './modules/sale-outbound';

export default [...inboundChains, ...inventoryChains, ...saleOutboundChains];
